import { useQuery } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { searchMasterProducts } from '../services/masterProductsApi';

export default function useMasterProducts(options = {}) {
  const { query = '', category = null, brand = null, limit = 20 } = options;
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  const { getAccessTokenSilently } = useAuth0();

  // Debounce search query
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(query);
    }, 300);

    return () => clearTimeout(timer);
  }, [query]);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['masterProducts', debouncedQuery, category, brand, limit],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return searchMasterProducts(token, debouncedQuery, { category, brand, limit });
    },
    enabled: debouncedQuery.length >= 2 || !!category,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000 // 10 minutes
  });

  return {
    products: data || [],
    isLoading,
    error,
    refetch,
    searchProducts: refetch
  };
}
